import React, { useEffect, useState } from "react";
import { fetchTestsByType } from "../../utils/testTypeAPI";
import TestCard from "./TestCard";

const TestListLayout = ({ type, title }) => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check login
  const isLoggedIn = Boolean(localStorage.getItem("token"));

  useEffect(() => {
    const loadTests = async () => {
      try {
        const data = await fetchTestsByType(type, isLoggedIn);
        setTests(data);
      } catch (err) {
        const msg = err?.response?.data?.message || "No tests found.";
        setError(msg);
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadTests();
  }, [type, isLoggedIn]);

  // --------------------------------------
  // Loading UI
  // --------------------------------------
  if (loading)
    return (
      <div className="p-6 flex justify-center items-center">
        <div className="animate-spin h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full"></div>
        <p className="ml-3 text-gray-500 text-lg">Loading {title}...</p>
      </div>
    );

  // --------------------------------------
  // Error UI
  // --------------------------------------
  if (error)
    return (
      <div className="p-6 text-center">
        <p className="text-red-500 text-lg font-medium">{error}</p>
      </div>
    );

  // --------------------------------------
  // No tests found UI
  // --------------------------------------
  if (!tests.length)
    return (
      <div className="p-6 text-center">
        <p className="text-gray-600 text-lg font-medium">No {title} found.</p>
      </div>
    );

  // --------------------------------------
  // Main UI
  // --------------------------------------
  return (
    <div className="p-6">
      {/* Title Section */}
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-3xl font-bold text-gray-800 tracking-wide">
          {title}
        </h1>

        {isLoggedIn ? (
          <span className="px-3 py-1 bg-green-100 text-green-600 rounded-lg text-sm font-medium">
            Logged In – Private + Public
          </span>
        ) : (
          <span className="px-3 py-1 bg-blue-100 text-blue-600 rounded-lg text-sm font-medium">
            Guest Mode – Public Only
          </span>
        )}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeIn">
        {tests.map((test) => (
          <div key={test._id} className="transform hover:scale-[1.02] transition duration-300">
            <TestCard test={test} type={type} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestListLayout;
